<template>
    <v-container class="fill-height justify-start align-start">
        <v-row>
            <v-col cols="12" sm="12" md="6">
                <v-card >
                    <v-toolbar>
                        <v-toolbar-title>{{ title }}</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text >
                        <v-form @submit.prevent="save">
                            <v-text-field label="Short Name" variant="outlined" v-model="name" ></v-text-field>
                            <v-text-field label="Long Name" variant="outlined" v-model="longName" ></v-text-field>
                            <v-text-field label="Address" variant="outlined" v-model="address" ></v-text-field>
                            <v-text-field label="Email" variant="outlined" v-model="email" ></v-text-field>
                            <v-text-field label="Postal Code" variant="outlined" v-model="postalCode" ></v-text-field>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn variant="elevated" color="primary" class="ml-2 mr-3" @click="save" >Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
            <v-col cols="12" sm="12" md="6">
                <v-expansion-panels v-model="panles">
                    <v-expansion-panel title="Reports">
                        <v-expansion-panel-text>
                            <v-text-field label="Prefix" variant="outlined" v-model="prefix" ></v-text-field>
                            <v-text-field label="Start Number" variant="outlined" v-model="startNumber" ></v-text-field>
                            <v-text-field label="End Number" variant="outlined" v-model="endNumber" ></v-text-field>
                        </v-expansion-panel-text>
                    </v-expansion-panel>
                    <v-expansion-panel title="Projects">
                        <v-expansion-panel-text>
                            <v-text-field label="Prefix" variant="outlined" v-model="projectPrefix" ></v-text-field>
                            <v-text-field label="Start Number" variant="outlined" v-model="projectStartNumber" ></v-text-field>
                            <v-text-field label="End Number" variant="outlined" v-model="projectEndNumber" ></v-text-field>
                        </v-expansion-panel-text>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-col>
        </v-row>
        <v-snackbar v-model="snackbar" >{{ message }}
            <template v-slot:actions>
                <v-btn
                    icon="mdi-close"
                    variant="text"
                    @click="snackbar = false"
                    :timeout="timeout"
                    ></v-btn>
            </template>
        </v-snackbar>
    </v-container>
</template>

<script>
import OrganizationApi from '@/services/OrganizationApi';
import { useStore } from '@/services/store'

    export default {
        name: "SettingPage",
        data() {
            return {
                id: 0,
                title: "Organization",
                name: "",
                longName: "",
                endNumber: 0,
                startNumber: 0,
                prefix: "",
                address: "",
                panles: [0],
                email: "",
                postalCode: "",
                projectEndNumber: "",
                projectStartNumber: "",
                projectPrefix: "",
                message: "",
                snackbar: false,
                timeout: 2000
            }
        },
        mounted() {
            const store = useStore()

            OrganizationApi.get(store.organization)
                .then((response) => {
                    if(response.data && response.data.state) {
                        this.name = response.data.name;
                        this.longName = response.data.longName;
                        this.address = response.data.address;
                        this.email = response.data.email;
                        this.postalCode = response.data.postalCode;

                        this.prefix = response.data.prefix;
                        this.startNumber = response.data.startNumber;
                        this.endNumber = response.data.endNumber;

                        this.projectPrefix = response.data.projectPrefix;
                        this.projectStartNumber = response.data.projectStartNumber;
                        this.projectEndNumber = response.data.projectEndNumber;
                    }
                });
        },
        methods: {
            save() {
                const store = useStore()

                OrganizationApi.put(store.organization, {
                    organizationId: store.organization,
                    name: this.name,
                    longName: this.longName,
                    address: this.address,
                    email: this.email,
                    postalCode: this.postalCode,
                    prefix: this.prefix,
                    startNumber: this.startNumber,
                    endNumber: this.endNumber,
                    projectPrefix: this.projectPrefix,
                    projectStartNumber: this.projectStartNumber,
                    projectEndNumber: this.projectEndNumber
                })
                .then((response) => {
                    if(response.data && response.data.state) {
                        this.message = response.data.state.message;
                        this.snackbar = true;
                    }
                });
            }
        }
    }

</script>